import { useState, useEffect, type FC, type RefObject } from "react";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

import { x_LARGE_SCREEN } from "../../../assets/Utils/generic";

import usePrevious from "../../hooks/usePrevious";

import { cn } from "../../../assets/Utils/generic";

type LoadingBarProps = {
  progress: number;
  leftColumnRef: RefObject<HTMLDivElement>;
};

const LoadingBar: FC<LoadingBarProps> = ({ progress, leftColumnRef }) => {
  const [isAnimationEnded, setIsAnimationEnded] = useState(false);
  const prevIsAnimationEnded = usePrevious(isAnimationEnded);

  const [progressWidth, setProgressWidth] = useState(0);

  const isxLargeScreen = useMediaQuery({ query: x_LARGE_SCREEN });
  const isShortScreen = useMediaQuery({
    query: "only screen and (max-height : 600px)",
  });

  useEffect(() => {
    if (progress === 1) {
      setTimeout(() => {
        setIsAnimationEnded(true);
      }, 300);
    }

    if (!prevIsAnimationEnded && progress !== 1) {
      setIsAnimationEnded(false);
    }
  }, [progress]);

  useEffect(() => {
    if (progress >= 1) {
      setProgressWidth(leftColumnRef?.current?.offsetWidth ?? 0);
      return;
    }

    setProgressWidth((leftColumnRef?.current?.offsetWidth ?? 0) * progress);
  }, [progress]);

  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: `${progress * 100}%` }}
      data-loading={!isAnimationEnded}
      className={cn(
        "fixed left-0 h-1.5 bg-primary data-[loading=false]:bg-transparent top-[3.375rem] lg:top-[4.75rem] min-w-8 z-10",
        isShortScreen && "md:top-10 lg:top-[3.875rem]",
      )}
      transition={{
        duration: 0.3,
        ease: "easeInOut",
      }}
    />
  );
};

export default LoadingBar;
